module.exports = __webpack_public_path__ + "static/media/bocongthuong2.28581f75.svg";